import React, { Component } from "react";
import {connect} from "react-redux";
import {withNamespaces} from "react-i18next";
import {networkDeviceContentActions} from "../../../../actions/network-device-content.actions";
import NetworkDeviceContentIconHelper from "../_helpers/NetworkDeviceContentIconHelper";
import {modalActions} from "../../../../actions/modal.actions";

class NetworkDeviceContentAddItemLauncherForm extends Component {

    state = {
        selectedContent: [],
        excludeItems: []
    }

    componentDidMount() {
        const { networkDeviceId, selectedItems, dispatch } = this.props;
        console.log(selectedItems);

        this.setState({
            ...this.state,
            excludeItems: selectedItems
        })

        dispatch(networkDeviceContentActions.getLauncherDropdown(networkDeviceId));
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.submit(this.state.selectedContent);
    }

    handleToggleElement = (model) => {
        this.handleCheck(model) ?
            this.setState({ selectedContent: this.state.selectedContent.filter((item,i) => item.id !== model.id) }) :
            this.setState({ selectedContent: [...this.state.selectedContent, model] });
    }

    handleCheck = (model) => {
        return this.state.selectedContent?.some(item => item.id === model.id);
    }

    handleCloseModal = () => {
        const { dispatch } = this.props;
        dispatch(modalActions.hideModal());
    }

    filterObjects = (arrayFull, arraySelected) => {
        return arrayFull.filter((item) => !arraySelected.some((item2) => item2.id === item.id));
    }

    render() {
        const { t, launcherDropdown } = this.props;

        const launcherDropdownParse = this.filterObjects(launcherDropdown, this.state.excludeItems);

        return (
            <React.Fragment>
                <form onSubmit={this.onSubmit}>
                    <ul className="list-group mb-4">

                        { launcherDropdownParse.length > 0 ? (
                            launcherDropdownParse?.map((item, idx) => {
                                return (
                                    <li key={idx} className={"list-group-item " + (this.handleCheck(item) ? "active" : "") } onClick={() => this.handleToggleElement(item)}>
                                        <input
                                            type="checkbox"
                                            className="form-check-inline"
                                            checked={this.handleCheck(item)}
                                            readOnly
                                        />
                                        <NetworkDeviceContentIconHelper type={item.defaultApp?.label} /> &nbsp;
                                        <b>{ item.label }</b> &nbsp; <small>ver. { item.version }</small>
                                    </li>
                                )
                            })
                        ) : (
                            <div className="text-center p-4">
                                <h5>{ t('content-no-items') }</h5>
                            </div>
                        )}


                    </ul>
                    <div className="form-group float-right">
                        { launcherDropdownParse.length > 0 ? (
                            <React.Fragment>
                                <button type="submit" className={"btn btn-primary mx-1" }>
                                    <i className="fas fa-check"> </i> {t('add-items')}
                                </button>
                                <button type="button" className={"btn btn-secondary mx-1"} onClick={this.handleCloseModal}>
                                    <i className="fas fa-times"> </i> {t('close')}
                                </button>
                            </React.Fragment>
                        ) : (
                            <i className="fas fa-2x fa-frown-open" />
                        )}
                    </div>
                </form>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    const { launcherDropdown } = state.networkDeviceContentReducer;
    return {
        launcherDropdown
    }
};
export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceContentAddItemLauncherForm));